export const PAGES_WITHOUT_BOTTOM_NAV = ["/read"];
